"use client";
import { Check } from "lucide-react";
import { usePatientDetailsContext } from "@/features/patient/context/PatientDetailsContext";
import CardBlock from "@/features/payment/components/CardBlock";

export function CardSavedView() {
  const { patient } = usePatientDetailsContext();
  return (
    <div className="flex flex-col items-center gap-4 pt-8 pb-4">
      <div className="animate-v5-check-pop flex size-16 items-center justify-center rounded-full bg-[#00A67F]">
        <Check
          className="animate-v5-check-draw size-8 text-white"
          strokeWidth={2.5}
        />
      </div>
      <p className="m-0 text-[15px] font-bold text-[#111827]">
        Card added on file
      </p>
      {patient?.cardOnFile && <CardBlock card={patient.cardOnFile} />}
    </div>
  );
}
